import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Lock, LogIn } from "lucide-react";
import AuthModal from "@/components/AuthModal";

const SignInOverlay = ({ children, message = "Sign in to access this content" }) => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [showAuth, setShowAuth] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const userToken = localStorage.getItem("user_token") || localStorage.getItem("token");
      const userData = localStorage.getItem("user_data") || localStorage.getItem("user");
      const hasSubscribed = localStorage.getItem("compoundr_subscribed");
      const sessionToken = sessionStorage.getItem("user_token");
      const sessionUser = sessionStorage.getItem("user_data");
      
      setIsUnlocked(!!userToken || !!hasSubscribed || !!userData || !!sessionToken || !!sessionUser);
    };
    
    checkAuth();
    // Listen for storage changes
    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  const handleAuthSuccess = (userData) => {
    localStorage.setItem("user_token", userData.token || "authenticated");
    localStorage.setItem("compoundr_subscribed", "true");
    setIsUnlocked(true);
    setShowAuth(false);
    window.location.reload();
  };

  if (isUnlocked) {
    return children;
  }

  return (
    <div className="relative min-h-screen">
      {/* Blurred/locked content preview */}
      <div className="pointer-events-none select-none">
        <div className="filter blur-sm opacity-50">
          {children}
        </div>
      </div>
      
      {/* Overlay - fixed to viewport center */}
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
        <div className="text-center p-8 max-w-md bg-white rounded-2xl shadow-xl">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-slate-400" />
          </div>
          <h3 className="text-xl font-bold text-slate-800 mb-2">Content Locked</h3>
          <p className="text-slate-600 mb-6">{message}</p>
          <Button 
            onClick={() => setShowAuth(true)}
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Sign In to Unlock
          </Button>
          <p className="text-sm text-slate-500 mt-4">
            Free to sign up • No credit card required
          </p>
        </div>
      </div>

      <AuthModal 
        isOpen={showAuth}
        onClose={() => setShowAuth(false)}
        onSuccess={handleAuthSuccess}
        required={true}
      />
    </div>
  );
};

export default SignInOverlay;
